import React, {useMemo} from 'react';
import styles from './styles.module.scss';
import {IoLogoAndroid} from 'react-icons/io';
import {devicesIcon} from '../../constants';
import {Platform} from 'enums/devices';
import classNames from 'classnames';

const DeviceTypeIcon: React.FC<{deviceType?: Platform, positionTop?: boolean}> = ({deviceType, positionTop}) => {
  const Icon = useMemo(() => {
    return deviceType && devicesIcon[deviceType] ? devicesIcon[deviceType] : IoLogoAndroid;
  }, [deviceType]);

  return (
    <div className={classNames(styles.device, {[styles.positionTop]: positionTop})}>
      {deviceType ? <Icon /> : null}
    </div>
  );
};

export default DeviceTypeIcon;